// src/hooks/useNotification.ts
import { useContext } from 'react';
import { ApiResponseHandlerContext } from './ApiResponseHandlerContext';

export const useApiResponseHandlerContext = () => {
  const context = useContext(ApiResponseHandlerContext);
  if (!context) {
    throw new Error('useApiResponseHandlerContext must be used within NotificationProvider');
  }
  return context;
};
